import { Link } from 'react-router-dom';
import OpenRotorMark from '@/components/base/OpenRotorMark';

const cols = [
  { title: 'Products', links: [['Ball Valves', '/products?category=Ball%20Valves'], ['Gate Valves', '/products?category=Gate%20Valves'], ['Butterfly Valves', '/products?category=Butterfly%20Valves'], ['Check Valves', '/products?category=Check%20Valves'], ['Actuators', '/products?category=Actuators']] },
  { title: 'Industries', links: [['Manufacturing', '/industries'], ['Energy', '/industries'], ['Water & Infrastructure', '/industries'], ['Process Industries', '/industries']] },
  { title: 'Supply Services', links: [['Product Selection', '/services'], ['Component Sourcing', '/services'], ['Documentation', '/services'], ['Procurement Support', '/services']] },
  { title: 'Company', links: [['About NORTHLINE', '/about'], ['Support & FAQ', '/support'], ['Request a Quote', '/request-quote']] },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-14 border-b border-foreground-800">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <OpenRotorMark size={34} />
              <div className="leading-none">
                <p className="font-heading tracking-[0.18em] text-foreground-50">NORTHLINE</p>
                <p className="font-label text-[9px] tracking-[0.3em] text-foreground-400 mt-1">FLOW SYSTEMS</p>
              </div>
            </div>
            <p className="mt-6 text-[15px] text-foreground-300 max-w-xs leading-relaxed">Industrial valves, flow-control components and accessories — supplied with care for B2B buyers.</p>
          </div>
          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <h4 className="eyebrow !text-[11px] text-foreground-400"><Link to={c.links[0][1]} className="cursor-pointer">{c.title}</Link></h4>
                <ul className="mt-5 space-y-3">
                  {c.links.map(([l, h]) => <li key={l}><Link to={h} className="text-sm whitespace-nowrap cursor-pointer hover:text-primary-400 transition-colors">{l}</Link></li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4 font-label text-[11px] tracking-[0.16em] text-foreground-400">
          <span>© 2026 NORTHLINE FLOW SYSTEMS</span>
          <span className="flex items-center gap-2"><OpenRotorMark size={14} />PRECISION COMPONENTS. DEPENDABLE SUPPLY.</span>
        </div>
      </div>
    </footer>
  );
}